import React, { useState } from 'react'
import Comment from './Comment'
import Options from './Options'
import styles from './ScoreCard.module.css'


const Questions = ({questions, sectionIndex, score, id}: any) => {

    const [showComments, setShowComments] = useState<Array<string>>([])

    const onToggleComment = (index: string) => {
        let updateList = [...showComments]
        let questionIndex = updateList.indexOf(index)
        if(questionIndex > -1) {
            updateList.splice(questionIndex, 1)
        } else {
            updateList.push(index)
        }
        setShowComments(updateList)
    }

    const questionsUI = questions && questions.map((question: any, index: number) => {
        if (!question || Object.keys(question).length === 0) {
            return null
        }

        const {name, options, answer, comment} = question
        return  <li className={`${styles.sectionQuestionContainer} bg-transparent py-3`} key={`question-${index}`}>
                    <h6 className="d-flex justify-content-between">
                       {`Q${index+1}.`} {name}
                       <span onClick={() => onToggleComment(`${sectionIndex}-${index}`)} className={styles.chatDots}>
                            <i className="bi bi-chat-dots fs-6 pe-1"></i>{answer?.comment ? 1 : ''}
                       </span>
                    </h6>
                    <ul className="list-unstyled m-0 d-flex justify-content-start">
                        <Options 
                            options={options} 
                            // sectionUUID={sectionUUID}
                            // questionUUID={index}
                            // sectionIndex={sectionIndex}
                            questionIndex={index}
                        />
                    </ul>
                    {
                        (showComments.includes(`${sectionIndex}-${index}`) || comment) ?
                            <Comment 
                                // sectionUUID={sectionUUID}
                                id={id}
                                questionUUID={`${sectionIndex}-${index}`}
                                sectionIndex={sectionIndex}
                                questionIndex={index}
                                onToggleComment={(questionUUID: string) => onToggleComment(questionUUID)}
                            /> :
                            null
                    }
                </li>
    })

    return (
        <>
            { questionsUI }
        </>
    )
}

export default Questions
